module.exports = __webpack_public_path__ + "img/bow-hera.924eea47.jpg";